module.exports = __webpack_public_path__ + "img/015.10e82a05.jpg";